import { Quote, X } from 'lucide-react';
import { cn } from '@/lib/utils';

export const writingQuotes = [
    { text: "The scariest moment is always just before you start.", author: "Stephen King" },
    { text: "Start writing, no matter what. The water does not flow until the faucet is turned on.", author: "Louis L'Amour" },
    { text: "You can always edit a bad page. You can't edit a blank page.", author: "Jodi Picoult" },
    { text: "Write what should not be forgotten.", author: "Isabel Allende" },
    { text: "The first draft is just you telling yourself the story.", author: "Terry Pratchett" },
    { text: "There is no greater agony than bearing an untold story inside you.", author: "Maya Angelou" },
    { text: "Write hard and clear about what hurts.", author: "Ernest Hemingway" },
    { text: "Don't tell me the moon is shining; show me the glint of light on broken glass.", author: "Anton Chekhov" },
    { text: "The road to hell is paved with adverbs.", author: "Stephen King" },
    { text: "Words are, of course, the most powerful drug used by mankind.", author: "Rudyard Kipling" },
    { text: "If there's a book that you want to read, but it hasn't been written yet, then you must write it.", author: "Toni Morrison" },
    { text: "Writing is the painting of the voice.", author: "Voltaire" },
];

interface WritingQuoteProps {
    quote: typeof writingQuotes[0];
    onClose: () => void;
    themeColors: any;
    className?: string;
}

export function WritingQuote({ quote, onClose, themeColors, className }: WritingQuoteProps) {
    return (
        <div
            className={cn("relative px-6 py-3 rounded-lg", className)}
            style={{
                backgroundColor: themeColors.quoteBg,
                border: `1px solid ${themeColors.border}`
            }}
        >
            <div className="flex items-start gap-3">
                <Quote className="w-4 h-4 flex-shrink-0 mt-0.5" style={{ color: themeColors.sage }} />
                <div className="flex-1">
                    <p className="text-sm italic" style={{ color: themeColors.textMuted }}>
                        "{quote.text}"
                    </p>
                    <p className="text-xs mt-1" style={{ color: themeColors.textSecondary }}>
                        — {quote.author}
                    </p>
                </div>
                <button
                    onClick={onClose}
                    className="p-1 rounded hover:bg-white/10 transition-colors"
                    style={{ color: themeColors.textMuted }}
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
}
